import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import commonCss from '~/core/css'
import { ColumnFlex, FlexCentered } from '~/components/common/containers'
import { SecondaryInfo } from '~/components/common/typography'
import useKeyboardAction from '~/components/hooks/use-keyboard-action'
import LinkTypeMappings from './link-type-mappings'
import FileSize from './file-size'

const Filename = styled.div`
  ${commonCss.textEllipsis};
  font-size: 14px;
`
const Url = styled.div`
  ${commonCss.textEllipsis};
`
const Author = styled(SecondaryInfo)`
  ${commonCss.textEllipsis};
`

const Container = styled(FlexCentered)`
  position: relative;
  margin-bottom: 16px;

  svg {
    flex-shrink: 0;
  }

  ${({ disabled }) => !disabled && 'cursor: pointer;'}

  ${({ shouldHover, disabled, theme }) => shouldHover && `
    &:hover {
      ${Filename}, ${Url} {
        ${!disabled && `color: ${theme._neo.action05};`}
      }
    }
  `}

  &:focus-visible {
      outline: 2px solid ${({ theme }) => theme._neo.focus01};
      outline-offset: -2px;
  }
`

const Info = styled(ColumnFlex)`
  flex-shrink: 1;
  margin-left: 16px;
  min-width: 0;

  b {
    font-weight: 600;
  }

  ${SecondaryInfo} {
    color: ${({ theme }) => theme.colorSecondary};
  }
`

const Link = ({
  disabled,
  fileName,
  sender,
  type,
  url,
  fileSizeBytes,
  linkClickedCallback
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const openLink = useCallback(() => {
    if (disabled) {
      return
    }

    linkClickedCallback(url, fileName)
  }, [url])
  const handleKeyUp = useKeyboardAction(openLink, disabled)

  return (
    <Container
      disabled={disabled}
      onClick={openLink}
      onKeyUp={handleKeyUp}
      title={url}
      onMouseLeave={() => setIsHovered(false)}
      onMouseEnter={() => setIsHovered(true)}
      shouldHover={!fileSizeBytes}
      role={disabled ? 'text' : 'button'}
      tabIndex={disabled ? -1 : 0}
      aria-label={`${fileName ?? ''}${sender ? `, shared by ${sender}` : ''}`}
    >
      {LinkTypeMappings[type]}
      <Info fullWidth>
        {fileName && <Filename>{fileName}</Filename>}
        {!fileName && <Url>{url}</Url>}

        <Author>{sender}</Author>
      </Info>
      {fileSizeBytes && <FileSize
        isHovered={isHovered}
        fileSizeBytes={fileSizeBytes}
                        />}
    </Container>
  )
}

export default Link
